const Vendor = {

    // PAGE HEADER
    "vendor": "Vendor",

    // FIELDS
    "premise": "Premise",
    "company_name": "Company Name",
    "contact_person": "Contact Person",
    "email": "Email",
    "mobile_number": "Mobile Number",
    "gst_number": "GST Number",
    "photo": "Photo",
    "city": "City",
    "address": "Address",
    "status": "Status",
    "search": "Search",

    // ERROR
    "error_premise": "Select Premise",
    "error_company_name": "Enter Company Name",
    "error_contact_person": "Enter Contact Person",
    "error_email": "Enter Email",
    "error_invalid_email": "Enter Valid Email",
    "error_mobile_number": "Enter Mobile Number",
    "error_invalid_mobile": "Enter Valid 10 Digit Mobile Number",
    "error_gst_number": "Enter GST Number",
    "error_invalid_gst": "Enter Valid GST Number",
    "error_city": "Select City",
    "error_status": "Select Status",
    "error_invalid_photo": "Only image files are allowed",

    // TABLE HEADERS
    "table_photo": "PHOTO",
    "table_company_name": "COMPANY NAME",
    "table_contact_person": "CONTACT PERSON",
    "table_mobile": "MOBILE",
    "table_email": "EMAIL",
    "table_gst": "GST NUMBER",
    "table_city": "CITY",
    "table_address": "ADDRESS",
    "table_status": "STATUS",
};

export default Vendor;